import { EnvironmentConfiguration } from "../app/models/environment-configuration";

const serverUrl='https://stage.mata-energy.de/api';


export const environment: EnvironmentConfiguration = {
  production: true,
  apiBaseUrl: serverUrl,
  adb2cConfig: {
    clientId: 'f02fc232-4b43-4636-a1b7-53409039480a',
    authority: 'https://matatest.b2clogin.com/matatest.onmicrosoft.com/B2C_1_susi',
    knownAuthorities: ['matatest.b2clogin.com'],
    redirectUri: 'https://stage.mein.mata-energy.de',
    postLogoutRedirectUri: 'https://stage.mein.mata-energy.de',
    apiEndpointUrl: serverUrl,
    oidcDefaultScopes: ['openid', 'https://matatest.onmicrosoft.com/51f59abc-da2d-4c9f-927e-b632670363a7/user_impersonation'],
    scopeUrls: ['https://matatest.onmicrosoft.com/51f59abc-da2d-4c9f-927e-b632670363a7/user_impersonation'],
  },
  cacheTimeInMinutes: 30,
};
